<template>
  <div class="">
    <alert v-if="deferredPrompt" :type="'success'" class="fixed top-0 w-full text-base md:text-lg">
      <p class="text-normal lg:text-lg mb-3">{{ __('pwa.bannertext') }}</p>
      <div class="btn-group flex flex-col lg:flex-row gap-5">
        <p><button class="block w-full lg:inline-block lg:w-auto btn btn-success" @click="install()">{{ __('pwa.install') }}</button></p>
        <p><button class="block w-full lg:w-auto btn btn-secondary" @click="refuse()">{{ __('pwa.dont_install') }}</button></p>
      </div>
    </alert>
    <alert v-else-if="differentBrowserPrompt" :type="'success'" class="fixed top-0 w-full text-base md:text-lg">
      <p class="text-normal lg:text-lg mb-3">{{ __('pwa.bannertext_alt') }}</p>
      <div class="btn-group flex flex-col lg:flex-row gap-5">
        <p><a href="/pwa-installieren" class="block w-full lg:inline-block lg:w-auto btn btn-success" @click="install()">{{ __('pwa.tutorial') }}</a></p>
        <p><button class="block w-full lg:w-auto btn btn-secondary" @click="refuse()">{{ __('pwa.dont_install') }}</button></p>
      </div>
    </alert>
  </div>
</template>

<script>
export default {
  name: 'InstallAppBanner',

  data() {
    return {
      deferredPrompt: null,
      differentBrowserPrompt: false, // if true, we can ask on a different browser
    }
  },

  computed: {
    isMobile() {
      const BREAKPOINT_DESKTOP_WIDTH = 768
      const maxWidth = Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth,
      )
      console.log( maxWidth )
      return maxWidth < BREAKPOINT_DESKTOP_WIDTH
    },

    isPwaBrowser() {
      var isChromium = window.chrome
      var winNav = window.navigator
      var vendorName = winNav.vendor
      var isOpera = typeof window.opr !== 'undefined'
      var isIEedge = winNav.userAgent.indexOf('Edg') > -1
      var isIOSChrome = winNav.userAgent.match('CriOS')

      if (isIOSChrome) {
        return true
      } else if(
          isChromium !== null &&
          typeof isChromium !== 'undefined' &&
          vendorName === 'Google Inc.' &&
          isOpera === false &&
          isIEedge === false
      ) {
        return true
      } else {
        return false
      }
    },
  },

  created() {

    if( ! localStorage.refusePwa ) {
      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e
      })
    }

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null
    })

    this.differentBrowserPrompt = ( !this.isPwaBrowser && this.isMobile && ! localStorage.refusePwa )
  },

  methods: {
    async dismiss() {
      this.deferredPrompt = null
    },
    async install() {
      this.deferredPrompt.prompt()
    },

    refuse: function() {
      // stop the banner
      this.deferredPrompt = false
      this.differentBrowserPrompt = false

      localStorage.refusePwa = true
    },
  },

}
</script>

<style scoped>

</style>
